import { FC } from 'react';
import { CustomCard } from '@mybonum/ui';
import { Button, Typography } from 'antd';

import { getErrorContent } from './utils/get-error-content.ts';
import { IProps } from './types';

import styles from './styles.module.scss';

export const ErrorComponent: FC<IProps> = ({ errorCode, onButtonClick }) => {
    const data = getErrorContent(errorCode);

    return (
        <CustomCard className={styles['container']}>
            <Typography.Title className={styles['title']}>{data.title}</Typography.Title>
            <Typography.Text>{data.message}</Typography.Text>
            {onButtonClick && <Button onClick={onButtonClick}>{data.actionTitle}</Button>}
        </CustomCard>
    );
};
